import React from 'react'
import * as Styled from './ConvenienceMessage.styles'

const ConvenienceMessage = () => (
  <Styled.Container>
    <Styled.PrimaryMessage>Click &amp; Collect</Styled.PrimaryMessage>
    <span>Pay online, collect in store</span>
  </Styled.Container>
)

export default ConvenienceMessage
